<script setup>
import { ref } from "vue"
import { Icon } from '@components'

import { useGeneral } from '@store/general'
const { sidebarOptions } = useGeneral()

import { useRouter } from 'vue-router'
const router = useRouter()

const props = defineProps({
    badgeValue: {
        type: String,
    },
    menuIcon: {
        type: String,
    },
    route: {
        type: Object,
    }
})

const showMenu = ref(false)


/**
 * Get current route name from router
 * 
 * @returns {String}
 */
const currentRouteName = () => {
    return router.currentRoute.value.name
}


const menuItemWrapper = ref(null)

/**
 * Generates a click animation effect when a button is clicked.
 *
 */
const clickAnimation = () => {
    let x = event.clientX - menuItemWrapper.value.offsetLeft
    let y = event.clientY - menuItemWrapper.value.offsetTop

    let bubble = document.createElement('div')

    bubble.classList.add('bubble')
    bubble.style.backgroundColor = '#adb2bc'
    bubble.style.position = 'absolute'
    bubble.style.left = x + 'px'
    bubble.style.top = y + 'px'
    menuItemWrapper.value.appendChild(bubble)

    setTimeout(() => {
        bubble.remove()
    }, 500)
}

import { useSettings } from '@store/settings'
const $settings = useSettings()

const navigateToRoute = (routeName) => {
    if(routeName == 'customizer'){
        let url = prebook_admin.url.home + prebook_admin.url.current + router.resolve({ name: routeName }).href;
        window.location.href = url;
        window.location.reload();
    }else{
        router.push({ name: routeName })
    }
}
</script>

<template>
    <div @click="navigateToRoute(props.route.name), showMenu = !showMenu, clickAnimation()" :class="`transition-all duration-300 overflow-hidden group relative flex items-center justify-between text-base font-semibold cursor-pointer hover:bg-[#F2F4F7] hover:text-[#101828] rounded-md ${currentRouteName() == props.route.name ? 'bg-[#F2F4F7] text-[#101828]' : 'text-[#344054]'} ${!sidebarOptions.sidebarCollapse ? 'px-3 py-2' : 'p-3'}`">
        <div class="flex items-center gap-3" ref="menuItemWrapper">
            <Icon :name="props.menuIcon" size="24px" class="group-hover:text-[#101828] transition" :class="currentRouteName() == props.route.name ? 'text-[#101828]' : 'text-[#667085]'" />
            <slot v-if="!sidebarOptions.sidebarCollapse"></slot>
        </div>
        <Icon v-if="!sidebarOptions.sidebarCollapse && !props.badgeValue && $slots.child" name="chevronDown" :class="`${showMenu ? 'rotate-180' : ''} transition-all duration-300`" />
        <div v-if="!sidebarOptions.sidebarCollapse && props.badgeValue" class="bg-[#F2F4F7] mix-blend-multiply px-2 py-0.5 rounded-2xl text-xs font-medium text-[#344054] text-center">
            {{ badgeValue }}
        </div>
    </div>

    <div v-if="!sidebarOptions.sidebarCollapse && $slots.child && showMenu" class="capitalize">
        <slot name="child"></slot>
    </div>
</template>
